module.exports = __webpack_public_path__ + "img/pause-btn.cd4823d3.svg";